export const enum IntegrationQueryCacheKey {
  GetExpertiseTramerDamage = 'GetExpertiseTramerDamage',
  GetTramerOldQueries = 'GetTramerOldQueries',
  GetTramerOldQueriesTramer360 = 'GetTramerOldQueriesTramer360',
  GetKmResults = 'GetKmResults',
  getExternalTramerQueries = 'getExternalTramerQueries',
  getExternalKilometerQueries = 'getExternalKilometerQueries',
}

export const enum TramerQueryType {
  Damage = 2,
  ChangedPart = 4,
  DetailDamage = 6,
  Tramer360Chassis = 26,
}

export const TramerQueryTypeLabel = new Map<number, string>([
  [TramerQueryType.Damage, 'Hasar Sorgulama'],
  [TramerQueryType.ChangedPart, 'Değişen Parça Sorgulama'],
  [TramerQueryType.DetailDamage, 'Araç Detay Sorgulama'],
  [TramerQueryType.Tramer360Chassis, 'Şasi ile Tramer360 Sorgulama'],
]);

export interface TramerDamageResponseData {
  damageDateKeyValue: string;
  queryTypeId: number;
  url: string;
  customerId: number;
  id: number;
  customer?: any;
  damageDateKeys: string;
}

export interface TramerDamageDateKeyResponse {
  orderId: number;
  value: string;
  damageDateKey: string;
}

export interface TramerDamageDateKey {
  orderId: number;
  value: string;
}

export interface TramerDamageData {
  url: string;
  damageDateKeys: TramerDamageDateKey[];
}

export interface TramerDamageResponse {
  tramerResult: TramerDamageResponseData;
  waitingResult: boolean;
}

export interface KmResultResponseData {
  chassis: string;
  imageUrl: string;
}

export interface InquiryTramerData {
  id: number;
  url: string;
  queryTypeId: number;
  createdAt: string;
  chassisNumber?: string;
  customerId?: number;
  damageDateKeys?: string;
  damageDateKeysArr: TramerDamageDateKeyResponse[];
  groupType?: number;
}

export interface InquiryKmData {
  chassis: string;
  createdAt: string;
  imageUrl: string;
  groupType?: number;
}
